import { useEffect } from "react";
import Services from "@/components/site/Services";

export default function ServicesPage() {
    useEffect(() => {
        document.title = "Services — MIDI Pictures";
    }, []);
    return (
        <main data-testid="services-page" className="bg-black pt-32">
            <Services />
        </main>
    );
}
